import classes from './Layout.module.css';
function Layout(props){
return <div className={classes.firstLayer} dir="rtl">
   <main className={classes.main}>
            {props.children}
    </main>
</div>
}
export default Layout;